import {Injectable} from '@angular/core';
import {AlertController, ToastController} from '@ionic/angular';


@Injectable({
    providedIn: 'root'
})
export class AlertService {
    save = 'ذخیره';
    dismiss = 'بستن';
    ok = 'باشه';
    cancel = 'انصراف';
    delete = 'حذف';
    // callback methods
    public okButtonCallBack: () => void;
    public cancelButtonCallBack: () => void;
    public additionalButtonCallBack: () => void;
    public deleteButtonCallBack: () => void;
    public saveButtonCallBack: () => void;
    public dismissButtonCallBack: () => void;
    public confirmOkButton: () => void;
    public confirmCancelButton: () => void;

    constructor(
        private alertCtrl: AlertController,
        private toast: ToastController
    ) {
    }

    async alert(pMessage: string,
                pHeader: string = null,
                pSubHeader: string = null) {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            subHeader: pSubHeader,
            message: pMessage,
            buttons: [
                {
                    text: this.ok,
                    handler: () => this.okButtonCallBack()
                }
            ]
        });
        await alert.present();
    }

    async confirm(pMessage: string,
                  pHeader: string = null,
                  pSubHeader: string = null) {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            subHeader: pSubHeader,
            message: pMessage,
            buttons: [
                {
                    text: this.ok,
                    handler: () => this.confirmOkButton()
                },
                {
                    text: this.cancel,
                    handler: () => this.confirmCancelButton()
                }
            ]
        });
        await alert.present();
    }

    async confirmYesNo(pMessage: string,
                  pHeader: string = null,
                  pSubHeader: string = null) {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            subHeader: pSubHeader,
            message: pMessage,
            buttons: [
                {
                    text: "بله",
                    handler: () => this.confirmOkButton()
                },
                {
                    text: "خیر",
                    handler: () => this.confirmCancelButton()
                }
            ]
        });
        await alert.present();
    }

    async confirmAdditionalButton(pMessage: string,
                                  pHeader: string = null,
                                  pSubHeader: string = null) {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            subHeader: pSubHeader,
            message: pMessage,
            buttons: [
                {
                    text: this.ok,
                    handler: () => this.okButtonCallBack()
                },
                {
                    text: 'ایجاد یادآوری',
                    handler: () => this.additionalButtonCallBack()
                },
                {
                    text: this.cancel,
                    handler: () => this.cancelButtonCallBack()
                }
            ]
        });
        await alert.present();
    }

    async confirmDelete(pMessage: string, pHeader: string = 'اعلان حذف') {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            message: pMessage,
            buttons: [
                {
                    text: this.delete,
                    handler: () => this.deleteButtonCallBack()
                },
                {
                    text: this.cancel,
                    handler: () => this.cancelButtonCallBack()
                }
            ]
        });
        await alert.present();
    }

    async confirmSaveDismiss(
        pMessage: string,
        pHeader: string = null,
        pSubHeader: string = null,
        pEnableBackdropDismiss: boolean = true
    ) {
        const alert = await this.alertCtrl.create({
            header: pHeader,
            message: pMessage,
            subHeader: pSubHeader,
            backdropDismiss: pEnableBackdropDismiss,
            buttons: [
                {
                    text: this.save,
                    handler: () => this.saveButtonCallBack()
                },
                {
                    text: this.dismiss,
                    handler: () => this.dismissButtonCallBack()
                }
            ]
        });
        await alert.present().then();
    }

    async shortPresentToast(pMessage: string,
                            header: string = 'اطلاع',
                            position: string = 'bottom'
    ) {
        const toast = await this.toast.create({
            message: pMessage,
            duration: 2000,
            // @ts-ignore
            position: position,
            header: header
        });
        toast.present().then();
    }

    async longPresentToast(pMessage: string,
                           pColor: string,
                           pDuration: number = 5000, keyboardClose: boolean = false) {
        const toast = await this.toast.create({
                message: pMessage,
                color: pColor,
                duration: pDuration,
                keyboardClose: keyboardClose
            })
        ;
        toast.present().then();
    }

    async presentToastWithOptions(pMessage: string,
                                  pHeader: string = null,
                                  pPosition: 'top' | 'middle' | 'bottom' = 'bottom',
                                  pColor: string,
                                  pButtonsOption = [],
                                  pDuration: number = 5000,
                                  pkeyboardClose: boolean = false) {
        const toast = await this.toast.create({
            header: pHeader,
            message: pMessage,
            keyboardClose: pkeyboardClose,
            position: pPosition,
            color: pColor,
            buttons: pButtonsOption,
            duration: pDuration
        });
        toast.present().then();
    }
}
